import * as TagApiUtil from "../../util/tag_util";

export const RECEIVE_ALL_TAGS = "RECEIVE_ALL_TAGS"
export const RECEIVE_TAGS = "RECEIVE_TAGS"
export const EDIT_WORK_INSTRUCTION = "EDIT_WORK_INSTRUCTION"
export const UPDATE_CURRENT_TAGS = "UPDATE_CURRENT_TAGS"
export const UPDATE_CREATED_TAGS = "UPDATE_CREATED_TAGS"
export const UPDATE_ADDED_TAGS = "UPDATE_ADDED_TAGS"
export const UPDATE_ASSIGNED_TAGS = "UPDATE_ASSIGNED_TAGS"
export const UPDATE_REMOVED_TAGS = "UPDATE_REMOVED_TAGS"

export const receiveAllTags = tags => {
    return {
        type: RECEIVE_ALL_TAGS,
        tags
    }
}

export const updateCurrentTags = tags => {
    return {
        type: UPDATE_CURRENT_TAGS, 
        tags
    }
}

export const updateAddedTags = tags => {
    return {
        type: UPDATE_ADDED_TAGS,
        tags
    }
}
export const updateAssignedTags = tags => {
    return {
        type: UPDATE_ASSIGNED_TAGS,
        tags
    }
}

export const updateRemovedTags = tags => {
    return {
        type: UPDATE_REMOVED_TAGS, 
        tags
    }
}

export const fetchAllTags = (cancelToken) => dispatch => {
    return TagApiUtil.fetchAllTags(cancelToken)
        .then(tags => { dispatch(receiveAllTags(tags)) })
};

export const assignTags = payload => dispatch => {
    return TagApiUtil.createTags(payload)
    .then((tags) => {
        tags = tags.data
        let reduxTags = tags.map(tag => {return {_id: tag._id, name: tag.name}})
        let wip_id = payload.wip_id
        let reducerPayload = {
            tags,
            reduxTags,
            wip_id
        }
        dispatch(updateAssignedTags(reducerPayload))
    })
};

export const EditTagsAdd = payload => dispatch => {
    return TagApiUtil.editTagsAdd(payload)
        .then((tags) => {
            tags = tags.data
            let reduxTags = tags.map(tag => ({ _id: tag._id, name: tag.name }))
            dispatch(updateAddedTags(reduxTags))
            return tags
        })
};

export const EditTagsRemove = payload => dispatch => {
    return TagApiUtil.editTagsRemove(payload)
        .then((tags) => {
            tags = tags.data
            dispatch(updateRemovedTags(tags))
            return tags
        })
};


export const fetchCurrentTags = WIID => dispatch => {
    return TagApiUtil.fetchCurrentTags(WIID).then(tags =>
        dispatch(updateCurrentTags(tags.data))
    )
}